import React, { useEffect, useState } from "react";
import whatsapp from "../../Images/Group 534.png";
import arrow2 from "../../Images/Vector (11).png";
import heart from "../../Images/Vector (10).png";
import arrow from "../../Images/Vector (8).png";
import plus from "../../Images/Vector@2x.png";
import redHeart from "../../Images/red-heart.png";

import "./PropertyList.css";
import HomeService from "../../Services/HomeService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
// import { openWhatsAppLink } from "../../Component/OpenWhatsApp";
const PropertyDisplay = ({ e, profile, handleClick }) => {
  console.log("isfavourite", e?.isFavorite);
  console.log("listProperty", e);

  const [show, setShow] = useState(false);
  const [isFavorite, setIsFavorite] = useState(e?.isFavorite || false);
  const [index, setIndex] = useState(null);
  const [userId, setUserId] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [propertyObject, setPropertyObject] = useState({});
  const navigate = useNavigate();
  const showFunc = () => {
    setShow(!show);
    setIndex(e._id);
  };
  const [favPropertyId, setFavPropertyId] = useState("");
  const [remarks, setRemarks] = useState("");
  const [showShareModal, setShowShareModal] = useState(false);

  useEffect(() => {
    setPropertyObject(e);
  }, [e]);

  const fetchLoginProfile = async () => {
    try {
      const response = await HomeService.getProfile();
      setUserId(response.data?._id || "");
    } catch (error) {
      console.error("Error fetching login profile:", error);
    }
  };

  useEffect(() => {
    fetchLoginProfile();
    // setIsFavorite(e?.isFavorite);
  }, []);

  const handleRemarksSubmit = async (id) => {
    console.log("data", remarks);
    try {
      const res = await HomeService.addRemarks({
        propertyId: id,
        remarks,
      });
      if (res?.status) {
        toast.success(res.message);
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.error("Error While adding Remarks!");
    }
    setRemarks("");
  };

  // const handleClick = async (propertyId) => {
  //   console.log("propertyId", propertyId);
  //   setFavPropertyId(propertyId);
  //   try {
  //     const data = { userId, propertyId };
  //     const res = await HomeService.addToWishList(data);
  //     console.log("JHG35", res);

  //     console.log("wishlist adding status", res);

  //     if (res?.status) {
  //       setIsFavorite((prev) => !prev);
  //       toast.success(res?.message);
  //       // setIsClicked(!isClicked);
  //     } else {
  //       console.error("Failed to add property to wishlist:", res?.message);
  //     }
  //   } catch (error) {
  //     console.error("Error adding property to wishlist:", error);
  //   }
  // };

  const handleClickFavourite = async (e, propertyId) => {
    console.log("propertyId", propertyId);
    setFavPropertyId(propertyId);
    handleClick(e, propertyId);
    setIsFavorite((prev) => !prev);
  };

  // useEffect(() => {
  //   setIsFavorite((prev) => !prev);
  // }, [isClicked]);

  const getShareMessage = () => {
    const priceText = e?.price
      ? `${e.price} ${e.priceUnit === "CR" ? "Crore" : e.priceUnit === "LKH" ? "Lakh" : e.priceUnit === "TH" ? "Thousand" : ""}`
      : "Call for price";

    const addressParts = [
      e?.aptName,
      e?.address,
      e?.locality?.name,
      e?.city?.name,
    ].filter(Boolean);
    const locationText =
      addressParts.length > 0 ? addressParts.join(" ") : "N/A";

    return `Hello Sir/Ma'am,\nWe have found a property that may suit your requirement.\nDetails:\n• Property Type: ${e?.propertytype?.propertyType || "N/A"}\n• Purpose (Sale/Rent): ${e?.propertyFor || "N/A"}\n• Location/Address: ${locationText}\n• Area: ${e?.area ? `${e.area} ${e.unit || ""}` : "N/A"}\n• BHK/Configuration: ${e?.bhk || "N/A"}\n• Price/Rent: ${priceText}\nPlease let us know if you're interested or need more options.\nThank you.\n\nWebsite link: https://www.thewinners2.in/\nDownload link (Android App): https://play.google.com/store/apps/details?id=com.winners.properties\nDownload link (iOS App)`;
  };

  const handleShareWhatsApp = (e_event) => {
    if (e_event) e_event.stopPropagation();
    const phoneNumber = e?.phoneNo ? `91${e.phoneNo.slice(0, 10)}` : "";
    openWhatsAppLink(e_event, phoneNumber, getShareMessage());
    setShowShareModal(false);
  };

  const handleShareGmail = (e_event) => {
    if (e_event) e_event.stopPropagation();
    const subject = `${e?.propertytype?.propertyType || "Property"} in ${e?.locality?.name || "our listings"}`;
    const body = getShareMessage();

    // Direct Gmail URL jate mailto popup na ase
    const gmailComposeUrl = `https://mail.google.com/mail/?view=cm&fs=1&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}&to=`;

    window.open(gmailComposeUrl, "_blank");
    setShowShareModal(false);
  };

  const handleShareClick = (e_event) => {
    if (e_event) e_event.stopPropagation();
    setShowShareModal(true);
  };

  const openWhatsAppLink = (e, phoneNumber, textMessage) => {
    e.preventDefault();

    const encodedText = encodeURIComponent(textMessage);

    const link = `https://wa.me/${phoneNumber}?text=${encodedText}`;

    window.open(link, "_blank");
  };
  const parts = [
    e?.aptName,
    e?.locality?.name,
    e?.city?.name,
    e?.address,
  ].filter(Boolean);
  const fullAddress = parts.join(", ");

  const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
    fullAddress,
  )}`;

  const handleViewProperty = async (id) => {
    try {
      const res = await HomeService.clickCountAndViewProperty({
        propertyId: id,
      });
      console.log("view count", res);
      if (res?.status && res?.data?.clickCount < 3) {
        setPropertyObject((prev) => ({
          ...prev,
          visibility: res?.data?.visibility,
        }));
      } else {
        toast.error(res?.message);
        navigate("/pricingplan");
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.message);
    }
  };

  return (
    <>
      <tr
        className={show && "borderClass"}
        onClick={() => {
          showFunc(e._id);
        }}
        style={{ backgroundColor: e?.newEntry === "$" ? "#9df084" : "" }}
      >
        <td>
          <div
            // style={{
            //   display: "flex",
            //   justifyContent: "space-between",
            //   alignItems: "center",
            //   columnGap: "10px",
            // }}
            className="poin"
          >
            <p className="table_data_para">{e?.locality?.name || "Null"}</p>
            <img
              style={{ cursor: "pointer" }}
              className="arrow_icon_blue"
              onClick={() => {
                // setIsFavorite(e?.isFavorite);
                setShow(!show);
              }}
              src={arrow}
            ></img>
          </div>
        </td>
        {/* <td><p className="table_data_para">{e?.aptName}</p></td> */}
        <td>
          <p className="table_data_para">
            {e?.address || "Null"}
            {e?.newEntry || ""}
          </p>
        </td>
        <td>
          <p className="table_data_para">{`${e?.area || "Null"} ${
            e?.unit || ""
          }`}</p>
        </td>
        <td>
          <p className="table_data_para">{e?.floor || "Null"}</p>
        </td>
        <td>
          <p className="table_data_para">{e?.bhk || "Null"}</p>
        </td>
        <td>
          {/* <div className='plus_div'>
                        <img style={{ cursor: 'pointer' }} src={plus}></img>
                    </div> */}
        </td>
      </tr>

      {show && (
        <>
          <tr style={{ borderLeft: "4px solid rgb(1, 51, 102)" }}>
            <td colSpan={7}>
              <tr>
                <td
                  className="table_inside_data"
                  style={{ border: "none !important" }}
                >
                  City:
                </td>
                <td
                  className="table_inside_data"
                  style={{ border: "none !important" }}
                >
                  Property Type:
                </td>
                <td
                  className="table_inside_data"
                  style={{ border: "none !important" }}
                >
                  Available for:
                </td>
                <td
                  className="table_inside_data"
                  style={{ border: "none !important" }}
                >
                  {e?.contactType} Name:
                </td>
                <td
                  className="table_inside_data"
                  style={{ border: "none !important" }}
                >
                  Contact:
                </td>
                <td
                  className="table_inside_data"
                  style={{ border: "none !important" }}
                >
                  Age:
                </td>
                <td
                  className="table_inside_data"
                  style={{ border: "none !important" }}
                >
                  Price:
                </td>
                {/* <td
                  className="table_inside_data"
                  style={{ border: "none !important" }}
                >
                  Extra:
                </td> */}
              </tr>

              <tr>
                <td
                  className="table_data_1"
                  style={{
                    filter: !propertyObject?.visibility ? "blur(4px)" : "",
                  }}
                >
                  {e?.city?.name || "Null"}
                </td>
                <td
                  className="table_data_1"
                  style={{
                    filter: !propertyObject?.visibility ? "blur(4px)" : "",
                  }}
                >
                  {e?.propertytype?.propertyType || "Null"}
                </td>
                <td
                  className="table_data_1 text-capitalize"
                  style={{
                    filter: !propertyObject?.visibility ? "blur(4px)" : "",
                  }}
                >
                  {e?.propertyFor || "Null"}
                </td>
                <td
                  className="table_data_1"
                  style={{
                    filter: !propertyObject?.visibility ? "blur(4px)" : "",
                  }}
                >
                  {e?.name || "Null"}
                </td>
                <td
                  className="table_data_1"
                  style={{
                    filter: !propertyObject?.visibility ? "blur(4px)" : "",
                  }}
                >
                  {e?.phoneNo || "Null"}
                </td>
                <td
                  className="table_data_1"
                  style={{
                    filter: !propertyObject?.visibility ? "blur(4px)" : "",
                  }}
                >
                  {e?.age || "Null"}
                </td>
                <td
                  className="table_data_1"
                  style={{
                    filter: !propertyObject?.visibility ? "blur(4px)" : "",
                  }}
                >
                  {/* <i class="fa fa-indian-rupee-sign"></i> */}
                  {e?.price || "Call For Price"}{" "}
                  {e?.priceUnit === "CR"
                    ? "Crore"
                    : e?.priceUnit === "LKH"
                      ? "Lakh"
                      : e?.priceUnit === "TH"
                        ? "Thousand"
                        : ""}
                </td>
                {/* <td className="table_data_1">{e?.remarks || "N/A"}</td> */}
              </tr>
              <tr>
                <td className="table_inside_data">Extra:</td>
                <td className="table_inside_data">Appartment Name:</td>
              </tr>
              <tr>
                <td
                  className="table_data_1"
                  style={{
                    filter: !propertyObject?.visibility ? "blur(4px)" : "",
                  }}
                >
                  {e?.extra || "Null"}
                </td>
                <td
                  className="table_data_1"
                  style={{
                    filter: !propertyObject?.visibility ? "blur(4px)" : "",
                  }}
                >
                  {e?.aptName || "Null"}
                </td>
                <td
                  className="table_data_1"
                  style={{
                    filter: !propertyObject?.visibility ? "blur(4px)" : "",
                    marginTop: "10px",
                  }}
                >
                  {/* {e?.locationUrl && (
                    <span style={{ marginLeft: "15px", cursor: "pointer" }}>
                      <a href={e?.locationUrl} target="_blank">
                        <i
                          class="fa-solid fa-location-dot"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </a>
                    </span>
                  )} */}
                  {e?.locationUrl ? (
                    <span style={{ marginLeft: "15px", cursor: "pointer" }}>
                      <a
                        href={e?.locationUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          class="fa-solid fa-location-dot"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </a>
                    </span>
                  ) : (
                    <span style={{ marginLeft: "15px", cursor: "pointer" }}>
                      <a
                        href={mapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          class="fa-solid fa-location-dot"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </a>
                    </span>
                  )}
                </td>
              </tr>
              {/* <tr>
                <td className="table_data_1" style={{ marginTop: "10px" }}>
                  {e?.locationUrl && (
                    <span style={{ marginLeft: "15px", cursor: "pointer" }}>
                      <a href={e?.locationUrl} target="_blank">
                        <i
                          class="fa-solid fa-location-dot"
                          style={{ fontSize: "20px" }}
                        ></i>
                      </a>
                    </span>
                  )}
                </td>
              </tr> */}

              {/* <tr>
                            <td className='table_data50' colSpan={3} >
                                <div style={{ display: "flex", columnGap: '15px', marginTop: '12px' }}>
                                    <td className='table_data50'>
                                        <div className='table_inside_data_div'>
                                            <div className='table_div_check'></div>
                                            <p>Report this property</p>
                                        </div>
                                    </td>

                                    <td className='table_data50'>
                                        <div className='table_inside_data_div'>
                                            <div className='table_div_check'></div>
                                            <p>Sold Out</p>
                                        </div>
                                    </td>

                                    <td className='table_data50'>
                                        <div className='table_inside_data_div'>
                                            <div className='table_div_check'></div>
                                            <p>Rent Out</p>
                                        </div>
                                    </td>
                                </div>
                            </td>







                        </tr> */}

              {propertyObject?.visibility && (
                <tr>
                  <td className="table_data50" colSpan={6}>
                    <div style={{ marginTop: "10px", marginBottom: "15px" }}>
                      <p className="para_remark">Remark</p>
                      <div className="remark_div">
                        <input
                          type="text"
                          value={remarks}
                          onChange={(e) => {
                            setRemarks(e.target.value);
                          }}
                          placeholder="Type something for your own use... "
                        ></input>
                        <button
                          onClick={() => {
                            handleRemarksSubmit(e._id);
                            setRemarks("");
                          }}
                        >
                          Submit
                        </button>
                        <div className="table_data_icons_wrapper">
                          <div
                            className="table_icons"
                            style={{ cursor: "pointer" }}
                            onClick={(k) => handleClickFavourite(k, e._id)}
                          >
                            <img
                              src={isFavorite ? redHeart : heart}
                              alt=""
                            ></img>
                            {/* <img
                            src={e?.isFavorite ? redHeart : heart}
                            alt=""
                          ></img> */}
                          </div>

                          <div
                            className="table_icons"
                            style={{ cursor: "pointer" }}
                            // onClick={(k) =>
                            //   openWhatsAppLink(
                            //     k,
                            //     `91${e.phoneNo?.slice(0, 10)}`,
                            //     `Hi ${e.ownerName}, I am interested in your ${e.propertytype?.propertyType} at ${e.address}, ${e.locality?.name}`,
                            //   )
                            // }
                            onClick={(k) =>
                              openWhatsAppLink(
                                k,
                                `91${e.phoneNo?.slice(0, 10)}`,
                                // `Hi ${property.name}, I am interested in your ${property.propertytype?.propertyType} at ${property.address}, ${property.locality?.name}`,
                                `Hello Sir/Madam,\n\n` +
                                  `I saw your property on the Winners Real Estate Data Portal. I am interested in your ${e?.propertyType || "property"} at ${e?.address} \n\n` +
                                  `Broker Details:\n` +
                                  `${profile?.fullName} | ${profile?.companyName} \n` +
                                  `${profile?.businessField} | ${profile?.majorLocality} \n` +
                                  `Experience : ${profile?.workExpYear}\n` +
                                  `Phone : ${profile?.mobileNo}\n` +
                                  `Email : ${profile?.email}\n` +
                                  `Address : ${profile?.address}\n` +
                                  `Thank You \n` +
                                  `Website link: https://www.thewinners2.in/\n` +
                                  `Download link (Android App): https://play.google.com/store/apps/details?id=com.winners.properties`,
                              )
                            }
                          >
                            <img src={whatsapp}></img>
                          </div>
                          <div
                            className="table_icons"
                            style={{ cursor: "pointer" }}
                            onClick={(e_event) => handleShareClick(e_event)}
                          >
                            <img src={arrow2}></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              {!propertyObject?.visibility && (
                <tr>
                  <button
                    style={{
                      backgroundColor: "black",
                      color: "white",
                      marginTop: "10px",
                      padding: "5px 10px",
                      borderRadius: "5px",
                      border: "none",
                    }}
                    onClick={() => {
                      handleViewProperty(e?._id);
                    }}
                  >
                    View Property
                  </button>
                </tr>
              )}
            </td>
          </tr>
        </>
      )}
      {/* {show && (
        <>
          <tr style={{ borderLeft: "4px solid rgb(1, 51, 102)" }}>
            <td colSpan={7}>
              <tr>
                <td className="table_inside_data">Property Type:</td>
                <td className="table_inside_data">Available for:</td>
                <td className="table_inside_data">Owner Name:</td>
                <td className="table_inside_data">Contact:</td>
                <td className="table_inside_data">Age:</td>
                <td className="table_inside_data">Price:</td>
              </tr>

              <tr>
                <td className="table_data_1">
                  {e?.propertytype?.propertyType || "N/A"}
                </td>
                <td className="table_data_1 text-capitalize">
                  {e?.propertyFor || "N/A"}
                </td>
                <td className="table_data_1">{e?.ownerName || "N/A"}</td>
                <td className="table_data_1">{e?.phoneNo || "N/A"}</td>
                <td className="table_data_1">{e?.age || "N/A"}</td>
                <td className="table_data_1">
                  <i className="fa fa-indian-rupee-sign"></i>
                  {e?.price || ""} {e?.priceUnit || ""}
                </td>
              </tr>

              
              <tr>
                <td className="table_inside_data">Extra:</td>
                <td className="table_data_1" colSpan={5}>
                  {e?.remarks || "N/A"}
                </td>
              </tr>

              <tr>
                <td className="table_data50" colSpan={6}>
                  <div style={{ marginTop: "10px", marginBottom: "15px" }}>
                    <p className="para_remark">Remark</p>
                    <div className="remark_div">
                      <input
                        type="text"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        placeholder="Type something for your own use... "
                      />
                      <button
                        onClick={() => {
                          handleRemarksSubmit(e._id);
                          setRemarks("");
                        }}
                      >
                        Submit
                      </button>
                      <div className="table_data_icons_wrapper">
                        <div className="table_icons">
                          <img src={heart} alt="like" />
                        </div>
                        <div className="table_icons">
                          <img src={whatsapp} alt="share" />
                        </div>
                        <div className="table_icons">
                          <img src={arrow2} alt="forward" />
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </td>
          </tr>
        </>
      )} */}
      {showShareModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
          }}
          onClick={(e) => {
            e.stopPropagation();
            setShowShareModal(false);
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "12px",
              padding: "24px",
              width: "320px",
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              position: "relative",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={{
                position: "absolute",
                top: "12px",
                right: "12px",
                background: "none",
                border: "none",
                fontSize: "24px",
                lineHeight: "1",
                cursor: "pointer",
                color: "#888",
                padding: "4px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowShareModal(false);
              }}
            >
              &times;
            </button>
            <h3
              style={{
                margin: "0 0 24px 0",
                fontSize: "18px",
                color: "#333",
                fontWeight: "600",
              }}
            >
              Share Property
            </h3>
            <div
              style={{ display: "flex", gap: "48px", justifyContent: "center" }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                }}
                onClick={handleShareWhatsApp}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <img
                  src={whatsapp}
                  alt="WhatsApp"
                  style={{ width: "56px", height: "56px", marginBottom: "8px" }}
                />
                <span
                  style={{ fontSize: "15px", color: "#555", fontWeight: "500" }}
                >
                  WhatsApp
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  cursor: "pointer",
                  transition: "transform 0.2s",
                }}
                onClick={handleShareGmail}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = "scale(1.1)")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.transform = "scale(1)")
                }
              >
                <div
                  style={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "50%",
                    backgroundColor: "#f1f3f4",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginBottom: "8px",
                  }}
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
                      fill="#EA4335"
                    />
                  </svg>
                </div>
                <span
                  style={{ fontSize: "15px", color: "#555", fontWeight: "500" }}
                >
                  Gmail
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PropertyDisplay;
